import antdTranslations from "antd/lib/locale-provider/de_DE";

export default {
   antd: antdTranslations,
   locale: "de"
};
